import { getRuntimeBasePath } from '../helpers/BasePath';

export default {
  Funds: getRuntimeBasePath(process.env.GATSBY_FUNDS_API_BASE_URL),
  MinBank: getRuntimeBasePath(process.env.GATSBY_MINBANK_API_BASE_URL),
  Spare: getRuntimeBasePath(process.env.GATSBY_SPARE_API_BASE_URL),
};
